module.exports = __webpack_public_path__ + "media/High_danger_of_collision.37514d05.mp4";